import { useMediaStore } from '@/pinia/MediaStore'

export async function uploadFile (file, parent, parentId) {
  const formData = new FormData()
  formData.append('file', file.file)

  file.status = 'loading'

  const mediaStore = useMediaStore()
  try {
    await mediaStore.upload(file.id, formData, { parent, parentId })
    file.status = 'uploaded'
  } catch (error) {
    file.status = error
  }
}

export function uploadFiles (files, parent, parentId) {
  console.log(files)
  return Promise.all(files.map((file) => uploadFile(file, parent, parentId)))
}

export default function createUploader (parent, parentId) {
  return {
    uploadFile: function (file) {
      return uploadFile(file, parent, parentId)
    },
    uploadFiles: function (files) {
      return uploadFiles(files, parent, parentId)
    }
  }
}
